<script setup lang="ts">
import { LandCollection, type Land } from '@/models/Land'
import { onMounted, ref } from 'vue'

const {
    modelValue = null,
    dense = false,
    label = null,
} = defineProps<{
    modelValue: number | null
    dense?: boolean
    label?: string | null
}>()

const loading = ref(false)
const laender = new LandCollection()

const emit = defineEmits<{
    (e: 'update:model-value', id: number): void
    (e: 'landchange', land: Land): void
}>()

onMounted(() => {
    loading.value = true
    try {
        laender.query()
    } finally {
        loading.value = false
    }
})

function onSelect(value: number) {
    emit('update:model-value', value)
    const land = laender.find((l) => l.id === value)
    if (land) {
        emit('landchange', land)
    }
}
</script>

<template>
    <div>
        <div class="text-subtitle-1 text-medium-emphasis">{{ label }}</div>
        <v-select
            :items="laender ? laender.getModels() : []"
            class="inputfield"
            item-title="name"
            :dense="dense"
            item-value="id"
            :model-value="modelValue"
            :loading="loading"
            clearable
            clear-icon="fas fa-times"
            @update:modelValue="onSelect"
        ></v-select>
    </div>
</template>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
</style>
